import React from 'react';
import { Component } from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';
import { ChangeRequestStore, RequestStatus, RequestDto, ExtendedStatusValidation } from '../../../../../../stores/requests/requests-store';
import { resolve } from 'inversify-react';
import { IdentityService } from 'services/identity-service';
import { replaceAll } from 'utils/useful-functions';
import { userCanRejectGeaOrGmaRequest } from 'utils/extended-requests-utils';
import RequestRejectPopupTailwind from './request-reject-popup-tw';

interface RequestRejectButtonTailwindProps extends WithTranslation {
  requestId: string;
  requestStatus: RequestStatus;
  requestValidatorRoles: string[];
  changeRequestStore?: ChangeRequestStore;
  isGea: boolean;
  isGma: boolean;
  extendedStatusValidation: ExtendedStatusValidation;
  readOnly: boolean;

  onSuccess?: (request: RequestDto) => void;
  onError?: () => void;
}

interface RequestRejectButtonTailwindState {
  showRequestRejectPopup: boolean;
}

class RequestRejectButtonTailwind extends Component<RequestRejectButtonTailwindProps, RequestRejectButtonTailwindState> {
  static defaultProps = { onSuccess: () => {}, onError: () => {} };
  state: RequestRejectButtonTailwindState = { showRequestRejectPopup: false };

  @resolve(IdentityService)
  private identityService: IdentityService;

  handleOnCancel = () => this.setState({ showRequestRejectPopup: false });

  handleOnClick = () => this.setState({ showRequestRejectPopup: true });

  isVisible = (): boolean => this.isVisibleInCurrentStatus() && this.currentUserHasPermission();

  isVisibleInCurrentStatus = (): boolean => {
    const isVisibleInCurrentStatus = this.props.requestStatus.toString() === 'Pending';
    return isVisibleInCurrentStatus;
  };

  currentUserHasPermission = (): boolean => {
    const userInfo = this.identityService.getUserInfo();
    const { isGea, isGma, extendedStatusValidation, requestValidatorRoles, requestStatus } = this.props;

    if (IdentityService.isAdmin(userInfo)) return true;
    if (IdentityService.isReporting(userInfo)) return false;

    if ((requestValidatorRoles || []).includes(replaceAll(userInfo.activeRole, ' ', ''))) {
      if (isGma) return userCanRejectGeaOrGmaRequest('GMA', extendedStatusValidation, requestValidatorRoles, requestStatus, userInfo);

      if (isGea) return userCanRejectGeaOrGmaRequest('GEA', extendedStatusValidation, requestValidatorRoles, requestStatus, userInfo);

      return true;
    }
    return false;
  };

  render() {
    const { t, readOnly, onError, onSuccess, requestId } = this.props;
    const { showRequestRejectPopup } = this.state;
    const visible = this.isVisible();

    return (
      visible && (
        <>
          <button
            type="button"
            className={`flex-1 py-2 rounded border ${!readOnly ? 'border-gray-200 text-gray-400' : 'border-gray-400 text-gray-800'}
           font-semibold hover:bg-gray-100 transition-all text-sm`}
            onClick={this.handleOnClick}
            style={{ minWidth: 0 }}
            disabled={!readOnly}
          >
            {t('Reject')}
          </button>
          {showRequestRejectPopup && (
            <RequestRejectPopupTailwind
              requestId={requestId}
              open={showRequestRejectPopup}
              onCancel={this.handleOnCancel}
              onSuccess={onSuccess}
              onError={onError}
            />
          )}
        </>
      )
    );
  }
}

export default withTranslation()(RequestRejectButtonTailwind);
